import type { VehicleShapeDefinition } from './vehicleShape';

/**
 * Simple arrow shape for undefined vehicle symbols
 * Pointing forward (upward in normalized space)
 */
export const arrowShape: VehicleShapeDefinition = {
  vehicle: 'arrow_default',
  coordinateSystem: '2D',
  unit: 'normalized_percent',
  polygons: {
    arrow: [
      [50, 0], // tip
      [70, 30],
      [60, 30],
      [60, 100],
      [40, 100],
      [40, 30],
      [30, 30],
    ],
  },
};
